export class IssueType {
  code: string;
  name: string;
  prefix: string;
  icon: string;
  color: string;
  isSystem: boolean;
  isActive: boolean;
  label: string;

  constructor(payload?: any) {
    if (payload) {
      this.code = payload.code;
      this.name = payload.name;
      this.prefix = payload.prefix;
      this.icon = payload.icon;
      this.color = payload.color;
      this.isSystem = payload.isSystem;
      this.isActive = payload.isActive;
      this.label = payload.label;
    }
  }

  static createIssueTypes(result: Array<any>): IssueType[] {
    const issueTypes = new Array<IssueType>();
    if (result) {
      result.map((issueType) => {
        issueTypes.push(new IssueType(issueType));
      });
    }
    return issueTypes;
  }
}
